import styles from "./Footer.module.css";
// import Icons from "../Icons/Icons";
function Footer() {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <footer className={styles.footer}>
      {/* <div className={styles.footerContainer}>
        <div className={styles.about}>
          <h6>About</h6>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita
            culpa error fugiat doloremque sit, molestiae architecto molestias?
            Sint repudiandae in ipsa nostrum iure amet temporibus dolorem
            repellendus quas, esse neque.
          </p>
        </div>
        <div className={styles.logo}>
          <img
            src={process.env.PUBLIC_URL + "/assets/img/logo/logo-plain.png"}
            alt="abiodun-akanbi-favicon"
            loading="lazy"
          />
        </div>
        <div>
          <div className>
            <Icons />
          </div>
          <div className="items">
            <ul>
              <li>Get in Touch</li>
              <li>Portfolio</li>
              <li>All Projects</li>
              <li>About Me</li>
              <li>Blog</li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className={styles.copyright}>
        <p>
          &copy; Copyright {year} | All Rights Reserved | Developed by AkanbiJR
        </p>
      </div>
    </footer>
  );
}

export default Footer;
